import { render, staticRenderFns } from "./TextPostCreateView.vue?vue&type=template&id=009bf571&scoped=true&"
import script from "./TextPostCreateView.vue?vue&type=script&lang=ts&"
export * from "./TextPostCreateView.vue?vue&type=script&lang=ts&"
import style0 from "./TextPostCreateView.vue?vue&type=style&index=0&id=009bf571&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bf571",
  null
  
)

export default component.exports